export default __webpack_public_path__ + "static/media/starrtupImage.8748eae7.svg";